import { render } from "./tab-list-booking-client-cbp.vue?vue&type=template&id=479d00c6&ts=true"
import script from "./tab-list-booking-client-cbp.vue?vue&type=script&lang=ts"
export * from "./tab-list-booking-client-cbp.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__